import { Col, Modal, Row, Typography } from "antd";
import * as FormatUtils from "../utils/format";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { useAnalytics } from "src/hooks/analytics.hook";
import { useEffect } from "react";

type ModalProps = {
  isModalOpen?: boolean;
  closeModal?: any;
  transaction?: any;
};

const fields = [
  {
    key: "date_effect",
    label: "date",
    render: (element: any) => (
      <>{moment(element?.date_effect).format("DD-MM-YYYY hh:mm ")}</>
    ),
  },
 
  // {
  //   key: "date_operation",
  //   label: "dateOPeration",
  //   render: (element: any) => (
  //     <>{moment(element?.date_operation).format("DD-MM-YYYY hh:mm")}</>
  //   ),
  // },
  {
    key: "product_name",
    label: "name",
  },

  {
    key: "product_type",
    label: "productType",
  },
  {
    key: "amount_raw",
    label: "amountRaw",
    render: (element: any) => (
      <>{FormatUtils.currency.format(element?.amount_raw)}</>
    ),
  },
  {
    key: "amount_net",
    label: "amountNet",
    render: (element: any) => (
      <>{FormatUtils.currency.format(element?.amount_net)}</>
    ),
  },
  {
    key: "operation_type",
    label: "operationType",
  },
  {
    key: "operation_status",
    label: "status",
  },
  {
    key: "isin_code",
    label: "isinCode",
  },
  {
    key: "capital",
    label: "capital",
    render: (element: any) => (
      <>{FormatUtils.currency.format(element?.capital)}</>
    ),
  },
  {
    key: "interest",
    label: "interest",
    render: (element: any) => (
      <>{FormatUtils.currency.format(element?.interest)}</>
    ),
  },
  {
    key: "interest_rate",
    label: "interestRate",
  },
  {
    key: "prorata_temporis",
    label: "prorataTemporis",
  },
  {
    key: "shares",
    label: "shares",
  },
  {
    key: "fee",
    label: "fee",
    render: (element: any) => <>{FormatUtils.currency.format(element?.fee)}</>,
  },
  {
    key: "fee_rate",
    label: "feeRate",
    render: (element: any) => <>{element?.feeRate || 0}</>,
  },
  {
    key: "penalty",
    label: "penalty",
    render: (element: any) => (
      <>{FormatUtils.currency.format(element?.penalty)}</>
    ),
  },
  {
    key: "penalty_rate",
    label: "penaltyRate",
  },
  {
    key: "nav_operation",
    label: "navOperation",
  },
];

export const DetailransactionModal: React.FC<ModalProps> = ({
  isModalOpen,
  closeModal,
  transaction,
}) => {
  const { t } = useTranslation("transactions");

  const { track } = useAnalytics();

  useEffect(() => {
    if (isModalOpen) {
      track("Pop-up", {
        page_current: "my_transactions",
        popup_name: "transaction_details",
      });
    }
  }, [isModalOpen]);
  if (!transaction) {
    return <></>;
  }
  return (
    <Modal
      title="Transaction Details"
      open={isModalOpen}
      onCancel={() => closeModal()}
      footer={<></>}
    >
      <Row gutter={16}>
        {fields.map((elt) => {
          const data = elt.render
            ? elt.render(transaction)
            : transaction[elt.key];
          return (
            <>
              {data && (
                <Col
                  span={12}
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 24 }}
                  lg={{ span: 12 }}
                  className="flex lg:flex-col lg:items-start lg:justify-between pb-2 lg:pt-4 border-b border-gray-300 gap-2 items-center"
                >
                  <Typography color="blue-gray" className="font-medium text-xs">
                    {t(elt.label)}
                  </Typography>

                  <Typography
                    color="blue-gray"
                    className="lg:text-sm text-sm   font-bold"
                  >
                    {data}
                  </Typography>
                </Col>
              )}
            </>
          );
        })}
      </Row>
    </Modal>
  );
};
